import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-invoice-filter',
  templateUrl: './invoice-filter.component.html',
  styleUrls: ['./invoice-filter.component.scss']
})
export class InvoiceFilterComponent implements OnInit {
  @Output() filterChange: EventEmitter<any> = new EventEmitter<any>();

  public formGroup: FormGroup;

  constructor(
    private fb: FormBuilder,
  ) {
    this.formGroup = this.fb.group({
      statuses: [['today', 'overdue', 'parcial']],
      dateStart: [undefined],
      dateEnd: [undefined],
    });

    this.formGroup.valueChanges.subscribe((value) => {
      this.filterChange.emit(value);
    });
  }

  ngOnInit(): void {
  }
}
